import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Grid, Divider } from 'components/ui';
import DisplayName from 'components/ProductPage/DisplayName/DisplayName';
import Price from 'components/ProductPage/Price/Price';
import Info from 'components/ProductPage/Info';
import OnlineOnly from 'components/ProductPage/OnlineOnly/OnlineOnly';
import CallToAction from 'components/ProductPage/CallToAction';
import LayoutTop from 'components/ProductPage/LayoutTop/LayoutTop';
import mediaUtils from 'utils/Media';
import localeUtils from 'utils/LanguageLocale';
import RwdProductPageEN from 'components/ProductPage/locales/RwdProductPage_en_US';
import RwdProductPageFR from 'components/ProductPage/locales/RwdProductPage_fr_CA';

const { Media } = mediaUtils;
const getText = localeUtils.getLocalisedDataFromResource(RwdProductPageEN, RwdProductPageFR);

const DigitalProduct = ({ processSkuId, subtitle }) => {
    const currentProduct = useSelector(state => state.page.product, shallowEqual);
    const [isSkuReady, setIsSkuReady] = useState(false);

    useEffect(() => {
        processSkuId({
            get isSkuReady() {
                return isSkuReady;
            },
            set isSkuReady(val) {
                setIsSkuReady(val);
            }
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const { currentSku, productDetails = {} } = currentProduct;
    const { type, listPrice, salePrice, valuePrice } = currentSku;
    const aboutDescription = productDetails.longDescription || productDetails.shortDescription || currentProduct.shortDescription;
    const faqDescription = productDetails.suggestedUsage || currentProduct.suggestedUsage;

    return (
        <div>
            <LayoutTop
                sku={currentSku}
                product={currentProduct}
                content={{
                    top: (
                        <Fragment>
                            <DisplayName
                                sku={currentSku}
                                product={{
                                    brand: productDetails || currentProduct,
                                    displayName: subtitle
                                }}
                            />
                            <Price
                                sku={{
                                    type,
                                    listPrice,
                                    salePrice,
                                    valuePrice
                                }}
                            />
                        </Fragment>
                    ),
                    bottom: (
                        <Grid gap={[null, null, 5]}>
                            {currentSku && currentSku.isOnlineOnly ? (
                                <OnlineOnly />
                            ) : (
                                <Media greaterThan='sm'>
                                    <Divider />
                                </Media>
                            )}
                            {isSkuReady && (
                                <CallToAction
                                    sku={currentSku}
                                    product={currentProduct}
                                />
                            )}
                        </Grid>
                    )
                }}
            />
            {isSkuReady && aboutDescription && (
                <Info
                    title={getText('aboutTheProduct')}
                    currentSku={currentSku}
                    description={aboutDescription}
                    dataAt='about_the_product_title'
                />
            )}
            {isSkuReady && faqDescription && (
                <Info
                    title={getText('faq')}
                    description={faqDescription}
                    dataAt='faq_title'
                />
            )}
        </div>
    );
};

export default wrapFunctionalComponent(DigitalProduct, 'DigitalProduct');
